import { Control, FieldErrors, FieldValues, Path } from 'react-hook-form'
import { DropdownProps } from 'react-native-element-dropdown/lib/typescript/components/Dropdown/model'

import FormFieldSelect from '@/components/form/FormFieldSelect'
import Species from '@/enums/species'

type data = { label: string; value: string }

interface Props<C extends FieldValues, E extends FieldErrors> {
  control: Control<C, any>
  disabled?: boolean
  errors?: E
  fieldName?: Path<C>
  isLoading?: boolean
  submit?: () => void
}

const FormFieldSpecies = <C extends FieldValues, E extends FieldErrors>({
  control,
  errors,
  fieldName = 'species' as Path<C>,
  isLoading,
  submit,
  ...props
}: Props<C, E> & Partial<DropdownProps<data>>) => {
  return (
    <FormFieldSelect
      control={control}
      data={[
        { label: 'Dog', value: Species.Dog },
        { label: 'Cat', value: Species.Cat },
      ]}
      disable={props.disabled}
      errors={errors}
      fieldName={fieldName}
      isLoading={isLoading}
      label="Species"
      onBlur={submit}
      required={false}
      style={props.style}
    />
  )
}

export default FormFieldSpecies
